"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6772],{

/***/ 28218:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;

"use client";

var _interopRequireDefault = __webpack_require__(64836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));
var _jsxRuntime = __webpack_require__(85893);
var _default = exports.Z = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
}), 'StarSharp');

/***/ }),

/***/ 47879:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "At": function() { return /* binding */ getActiveTestimonialIndex; },
/* harmony export */   "C_": function() { return /* binding */ getImageWrapperStyles; },
/* harmony export */   "EX": function() { return /* binding */ getViewableTestimonials; },
/* harmony export */   "KG": function() { return /* binding */ getImageList; },
/* harmony export */   "Px": function() { return /* binding */ getAuthorImagePositionInfo; },
/* harmony export */   "S4": function() { return /* binding */ getAuthImageListMaxWidth; },
/* harmony export */   "Z$": function() { return /* binding */ scrollImageToConatinerCenter; },
/* harmony export */   "jF": function() { return /* binding */ getImageClassesL4; },
/* harmony export */   "l8": function() { return /* binding */ getStylesAndUtilsFromConfig; },
/* harmony export */   "p1": function() { return /* binding */ getWrapperStyles; },
/* harmony export */   "wy": function() { return /* binding */ getImageLimit; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var src_utils_deviceWidth__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86812);
/* harmony import */ var _Constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16902);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3310);






function getImageLimit(isMobile) {
    if (!isMobile) {
        return _Constants__WEBPACK_IMPORTED_MODULE_2__/* .IMAGE_LIMIT_L4.DESKTOP */ .e9.DESKTOP;
    }
    return src_utils_deviceWidth__WEBPACK_IMPORTED_MODULE_1__/* .deviceWidth */ .o <= 360 ? _Constants__WEBPACK_IMPORTED_MODULE_2__/* .IMAGE_LIMIT_L4.MOBILE_XS */ .e9.MOBILE_XS : _Constants__WEBPACK_IMPORTED_MODULE_2__/* .IMAGE_LIMIT_L4.MOBILE */ .e9.MOBILE;
}
function getImageClassesL4(isActive) {
    return isActive ? "tw-border-b tw-border-solid tw-border-[#000000]" : "tw-opacity-[70]";
}
function getImageWrapperStyles(imageShape) {
    var index = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    var blobBorderRadius = [
        "30% 70% 70% 30% / 30% 47% 53% 70%",
        "54% 46% 70% 30% / 19% 79% 21% 81%",
        "87% 13% 60% 40% / 30% 93% 7% 70%",
        "67% 33% 16% 84% / 63% 52% 48% 37%",
        "72% 28% 69% 31% / 67% 57% 43% 33%", 
    ];
    switch(imageShape){
        case "square":
            return {
                aspectRatio: 1
            };
        case "portraitTall":
            return {
                aspectRatio: 2 / 3
            };
        case "portraitShort":
            return {
                aspectRatio: 3 / 4
            };
        case "landscape":
            return {
                aspectRatio: 3 / 2
            };
        case "landscapeWide":
            return {
                aspectRatio: 4 / 3
            };
        case "circle":
            return {
                aspectRatio: 1,
                borderRadius: "9999px"
            };
        case "blob":
            return {
                aspectRatio: 1,
                borderRadius: blobBorderRadius[index % 5]
            };
        case "arch":
            return {
                aspectRatio: 3 / 4,
                borderRadius: "9999px 9999px 0px 0px"
            };
        default:
            return {};
    }
}
function getViewableTestimonials(param) {
    var cardFrameConfig = param.cardFrameConfig, isCarousel = param.isCarousel, isTestimonialListingPage = param.isTestimonialListingPage, containerTracks = param.containerTracks;
    var ref;
    var allTestimonials = (cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.testimonialsList) || [];
    var visibleTestimonials = allTestimonials === null || allTestimonials === void 0 ? void 0 : (ref = allTestimonials.filter) === null || ref === void 0 ? void 0 : ref.call(allTestimonials, function(testimonial) {
        return (testimonial === null || testimonial === void 0 ? void 0 : testimonial.isVisible) !== undefined ? testimonial === null || testimonial === void 0 ? void 0 : testimonial.isVisible : true;
    });
    // max rows for grid -> 2,  if not listing page.
    var shouldTruncateList = !isCarousel && !isTestimonialListingPage;
    return shouldTruncateList ? visibleTestimonials === null || visibleTestimonials === void 0 ? void 0 : visibleTestimonials.slice(0, containerTracks.numColumns * 2) : visibleTestimonials;
}
/**
 * This function return the updated list after the array rotation.
 * if limit is L, then the array would contain 2*L-1 element.
 * with L-1 elements for each side(left and right to the active image(testimonial) )
 */ function getImageList(param) {
    var showRotation = param.showRotation, totalItems = param.totalItems, activeTestimonialIdx = param.activeTestimonialIdx, viewAbleImageLimit = param.viewAbleImageLimit, testimonialsData = param.testimonialsData;
    var startIndex;
    var endIndex;
    // return the original array if rotation is not required
    if (!showRotation) {
        startIndex = 0;
        endIndex = totalItems - 1;
    } else {
        // negative indexes means elements from the end of array (-1 -> last element).
        startIndex = activeTestimonialIdx - (viewAbleImageLimit - 1);
        endIndex = activeTestimonialIdx + (viewAbleImageLimit - 1);
    }
    var imageList = [];
    // loop for generating new image list
    for(var i = startIndex; i <= endIndex; i++){
        var ref, ref1;
        var testimonailIndex = (totalItems + i) % totalItems;
        var testimonialData = testimonialsData.at(testimonailIndex);
        imageList.push({
            mediaUrl: (testimonialData === null || testimonialData === void 0 ? void 0 : (ref = testimonialData.authorMedia) === null || ref === void 0 ? void 0 : ref.link) || _Constants__WEBPACK_IMPORTED_MODULE_2__/* .DEFAULT_IMAGE */ .UF,
            mediaType: (testimonialData === null || testimonialData === void 0 ? void 0 : (ref1 = testimonialData.authorMedia) === null || ref1 === void 0 ? void 0 : ref1.type) || _Constants__WEBPACK_IMPORTED_MODULE_2__/* .MEDIA_TYPES.IMAGE */ .w_.IMAGE,
            index: testimonailIndex
        });
    }
    return imageList;
}
/**
 *  function to scroll image in case of  L4  to the center of it's conatiner.
 */ function scrollImageToConatinerCenter(param) {
    var element = param.element, _instantScroll = param.instantScroll, instantScroll = _instantScroll === void 0 ? false : _instantScroll, scrollerRef = param.scrollerRef, showLoader = param.showLoader, setShowLoader = param.setShowLoader;
    if (scrollerRef.current && element) {
        var container = scrollerRef.current;
        // half of container width
        var containerHalfWidth = container.offsetWidth / 2;
        // position of container
        var containerRect = container.getBoundingClientRect();
        var conatinerCenter = containerRect.left + containerHalfWidth;
        // postition of element
        var itemRect = element.getBoundingClientRect();
        // position of element's center
        var itemCenter = (itemRect.left + itemRect.right) / 2;
        // displacement of element's center from the container's center (element's center - conatiner's center)
        var positionFromCenter = itemCenter - conatinerCenter;
        // adjust the scroll position of element.
        container.scrollTo({
            left: container.scrollLeft + positionFromCenter,
            behavior: instantScroll ? "instant" : "smooth"
        });
        showLoader && setShowLoader(false);
    }
}
function getAuthorImagePositionInfo(param) {
    var pos = param.pos, isMobileAndL5 = param.isMobileAndL5;
    var positionInfo = {
        withAuthorInfo: pos === _Constants__WEBPACK_IMPORTED_MODULE_2__/* .TESTIMONIAL_IMAGE_POSITION.WITH_AUTHOR_INFO */ .eu.WITH_AUTHOR_INFO,
        top: pos === _Constants__WEBPACK_IMPORTED_MODULE_2__/* .TESTIMONIAL_IMAGE_POSITION.TOP */ .eu.TOP,
        bottom: pos === _Constants__WEBPACK_IMPORTED_MODULE_2__/* .TESTIMONIAL_IMAGE_POSITION.BOTTOM */ .eu.BOTTOM,
        left: pos === _Constants__WEBPACK_IMPORTED_MODULE_2__/* .TESTIMONIAL_IMAGE_POSITION.LEFT */ .eu.LEFT
    };
    if (isMobileAndL5 && positionInfo.left) {
        positionInfo = {
            withAuthorInfo: false,
            top: true,
            bottom: false,
            left: false
        };
    }
    return positionInfo;
}
function getActiveTestimonialIndex(param) {
    var carouselIndicatorConfigs = param.carouselIndicatorConfigs, totalItems = param.totalItems;
    return (carouselIndicatorConfigs.currentFocusedSectionItem - 1) % totalItems;
}
function getAuthImageListMaxWidth(param) {
    var viewAbleImageLimit = param.viewAbleImageLimit, isSmartShape = param.isSmartShape, containerWidthSmartShape = param.containerWidthSmartShape, imageSizeActive = param.imageSizeActive, imageSizeInactive = param.imageSizeInactive, imageGap = param.imageGap;
    var itemsExceptActive = viewAbleImageLimit - 1;
    var widthForInactiveItems = itemsExceptActive * (isSmartShape ? containerWidthSmartShape : imageSizeInactive);
    var widthForGapInBetween = itemsExceptActive * imageGap;
    var widthForActiveItem = isSmartShape ? containerWidthSmartShape : imageSizeActive;
    return widthForInactiveItems + widthForGapInBetween + widthForActiveItem;
}
// function to get Testimonial card wrapper styles
function getWrapperStyles(param) {
    var showBorder = param.showBorder, listPresentationConfig = param.listPresentationConfig, isSelected = param.isSelected, shouldAdjustCardPaddingX = param.shouldAdjustCardPaddingX;
    var className = showBorder ? " tw-border tw-border-solid " : "";
    var style = {};
    style = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, style), {
        borderColor: showBorder ? listPresentationConfig.borderColor : "",
        backgroundColor: showBorder ? listPresentationConfig.backgroundColor : ""
    }), isSelected ? {
        borderWidth: "1px",
        borderStyle: "solid",
        borderColor: "#2B74D8",
        backgroundColor: "#2B74D80F"
    } : {}, shouldAdjustCardPaddingX ? {
        paddingLeft: 20,
        paddingRight: 20
    } : {});
    return {
        style: style,
        className: className
    };
}
function getStylesAndUtilsFromConfig(param) {
    var isMobile = param.isMobile, cardFrameConfig = param.cardFrameConfig;
    var textSizeKey = !isMobile ? "textSizeDesktop" : "textSizeMobile";
    var headSizelineKey = !isMobile ? "headlineSizeDesktop" : "headlineSizeMobile";
    var imageWidthKey = !isMobile ? "imageSizeDesktop" : "imageSizeMobile";
    var textAlignmentStyle = (0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .getMappedProductTextAlign */ .sz)(cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.textAlign);
    var reviewStylesFromConfig = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, (0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .getMappedproductsTextSize */ .Im)(cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig[textSizeKey]), (0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .getMappedProductCasing */ .TI)(cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.textCase), (0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .getMappedProductTextThickness */ .aA)(cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.textThickness), textAlignmentStyle), {
        color: cardFrameConfig.reviewColor
    });
    var headlineStylesFromConfig = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, (0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .getMappedProductCasing */ .TI)(cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.headlineCase), (0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .getMappedproductsTextSize */ .Im)(cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig[headSizelineKey]), (0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .getMappedProductTextThickness */ .aA)(cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.headlineThickness)), {
        color: cardFrameConfig.headlineColor
    });
    var imageWidth = cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig[imageWidthKey];
    var isContentCenter = (cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.textAlign) === "center";
    var showRatings = cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.showRatings;
    var showImage = cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.showImage;
    return {
        reviewStylesFromConfig: reviewStylesFromConfig,
        headlineStylesFromConfig: headlineStylesFromConfig,
        textAlignmentStyle: textAlignmentStyle,
        imageWidth: imageWidth,
        isContentCenter: isContentCenter,
        showRatings: showRatings,
        showImage: showImage
    };
}


/***/ }),

/***/ 65397:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Testimonials": function() { return /* reexport */ Testimonials_Testimonials; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/tailwind-merge/dist/bundle-mjs.mjs
var bundle_mjs = __webpack_require__(98388);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_extends.mjs
var _extends = __webpack_require__(40872);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_throw.mjs
var _throw = __webpack_require__(51351);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentation/components/Testimonials/Constants/index.tsx
var Constants = __webpack_require__(16902);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/ProductCard/utils.tsx + 1 modules
var utils = __webpack_require__(81241);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/context/WidgetDndContext/index.ts
var WidgetDndContext = __webpack_require__(74151);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentation/hooks/useLayoutTypes.tsx
var useLayoutTypes = __webpack_require__(36017);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentation/components/Testimonials/Utils/index.tsx
var Utils = __webpack_require__(47879);
// EXTERNAL MODULE: ./src/components/WidgetMaker/WidgetDnD/globalLoader.tsx
var globalLoader = __webpack_require__(25480);
// EXTERNAL MODULE: ./src/components/WidgetMaker/WidgetDnD/WidgetProperties/TestimonialsBuilder/TestimonialRating.tsx
var TestimonialRating = __webpack_require__(18042);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentation/components/Testimonials/Components/Card/Rating.tsx



var Rating = function(param) {
    var isContentCenter = param.isContentCenter, isLayout4 = param.isLayout4, cardAnimationClass = param.cardAnimationClass, ratingCount = param.ratingCount, ratingColor = param.ratingColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()("tw-flex tw-w-full", isContentCenter ? "tw-justify-center" : "", isLayout4 ? cardAnimationClass : ""),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TestimonialRating/* TestimonialRating */.y, {
            ratingCount: ratingCount || 5,
            color: ratingColor || "#F9CC43"
        })
    });
};

;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentation/components/Testimonials/Components/Card/Review.tsx




var Review = function(param) {
    var authorImagePosition = param.authorImagePosition, isLayout4 = param.isLayout4, cardAnimationClass = param.cardAnimationClass, reviewStyles = param.reviewStyles, testimonialData = param.testimonialData, headlineStylesFromConfig = param.headlineStylesFromConfig, reviewStylesFromConfig = param.reviewStylesFromConfig, textAlignmentStyle = param.textAlignmentStyle, isMobile = param.isMobile, listPresentationConfig = param.listPresentationConfig;
    var shouldAdjustReviewLineHeight = function shouldAdjustReviewLineHeight() {
        var ref = listPresentationConfig || {}, numColumnsMobile = ref.numColumnsMobile, numColumnsDesktop = ref.numColumnsDesktop;
        var numColumns = isMobile ? numColumnsMobile : numColumnsDesktop;
        return numColumns === 1;
    };
    var checkTextClamping = function checkTextClamping() {
        if (textContainerRef.current) {
            var isTextClamped = textContainerRef.current.scrollHeight > textContainerRef.current.clientHeight;
            setReviewIsClamped(isTextClamped);
        }
    };
    var getLineClampClass = function getLineClampClass() {
        return isLayout4 ? "tw-line-clamp-2" : "tw-line-clamp-5";
    };
    var review = testimonialData.review, headline = testimonialData.headline;
    var ref = (0,react.useState)(false), isReviewClamped = ref[0], setReviewIsClamped = ref[1];
    var ref1 = (0,react.useState)(false), expandReview = ref1[0], setExpandReview = ref1[1];
    var textContainerRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        checkTextClamping();
        window.addEventListener("resize", checkTextClamping);
        return function() {
            window.removeEventListener("resize", checkTextClamping);
        };
    }, [
        review.length,
        textContainerRef.current
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()("tw-flex tw-max-w-[1000px] tw-flex-grow tw-flex-col tw-gap-[12px]", authorImagePosition.top ? "!tw-gap-[12px]" : "", isLayout4 ? cardAnimationClass : ""),
        style: reviewStyles,
        children: [
            !!(headline === null || headline === void 0 ? void 0 : headline.trim()) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "tw-m-0",
                style: (0,_object_spread/* default */.Z)({}, headlineStylesFromConfig, textAlignmentStyle),
                children: headline
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: (0,_object_spread/* default */.Z)({}, reviewStylesFromConfig, shouldAdjustReviewLineHeight() ? {
                    lineHeight: 1.6
                } : {}, textAlignmentStyle),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        ref: textContainerRef,
                        className: classnames_default()("tw-m-0", !expandReview ? getLineClampClass() : ""),
                        children: review
                    }),
                    isReviewClamped && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "tw-mt-[2px] tw-cursor-pointer tw-font-semibold",
                        style: textAlignmentStyle,
                        onClick: function() {
                            return setExpandReview(!expandReview);
                        },
                        children: !expandReview ? "Read more" : "Read less"
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentation/components/Testimonials/Components/Card/AuthorInfo.tsx




var AuthorInfo = function(param) {
    var isContentCenter = param.isContentCenter, authorImagePosition = param.authorImagePosition, isLayout4 = param.isLayout4, cardAnimationClass = param.cardAnimationClass, renderAuthorImage = param.renderAuthorImage, showImage = param.showImage, colorConfig = param.colorConfig, textAlignmentStyle = param.textAlignmentStyle, testimonialData = param.testimonialData, cardFrameConfig = param.cardFrameConfig, authornameStyles = param.authornameStyles, authorProfileStyles = param.authorProfileStyles;
    var authorName = testimonialData.authorName, authorDesignation = testimonialData.authorDesignation;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()("tw-flex tw-w-full  tw-gap-[12px]", isContentCenter && (authorImagePosition.bottom ? "tw-items-center" : "tw-justify-center"), authorImagePosition.bottom ? "tw-flex-col tw-justify-center" : "tw-items-center", isLayout4 ? cardAnimationClass : ""),
        children: [
            (authorImagePosition.withAuthorInfo || authorImagePosition.bottom) && renderAuthorImage(),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()("tw-flex tw-flex-col tw-gap-[2px] tw-text-[#050505]", isContentCenter && !showImage && "tw-text-center"),
                style: (0,_object_spread/* default */.Z)({
                    color: colorConfig.text
                }, !authorImagePosition.withAuthorInfo ? textAlignmentStyle : {}),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                        className: "tw-m-0",
                        style: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, authornameStyles), {
                            color: cardFrameConfig.authorNameColor
                        }),
                        children: authorName || "Anonymous"
                    }),
                    !!authorDesignation && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "tw-m-0 tw-text-[12px]",
                        style: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, authorProfileStyles), {
                            color: cardFrameConfig.designationColor
                        }),
                        children: authorDesignation
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentation/components/Testimonials/Components/Card/index.tsx















var Card = function(props) {
    var getImageStyleByType = function getImageStyleByType(param) {
        var _isVideo = param.isVideo, isVideo = _isVideo === void 0 ? false : _isVideo;
        var style = {};
        if (props.cardFrameConfig.authorImagePosition === "left") {
            if (isLayout5) {
                style.maxWidth = "300px";
                style.width = "".concat(cardWidth * (40 / 100), "px");
            } else {
                style.width = "".concat(imageWidth, "px");
                if (isVideo && props.cardFrameConfig.imageShape === Constants/* IMAGE_TYPES.CIRCLE */.v5.CIRCLE) {
                    style.height = "".concat(imageWidth, "px");
                }
            }
        } else {
            style.width = "".concat(imageWidth, "px");
        }
        return {
            style: style
        };
    };
    var renderAuthorImage = function renderAuthorImage() {
        var ref;
        if (!showImage) return null;
        var isVideo = authorMedia.type === Constants/* MEDIA_TYPES.VIDEO */.w_.VIDEO;
        var styling = getImageStyleByType({
            isVideo: isVideo
        });
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classnames_default()("tw-relative tw-flex tw-overflow-hidden", !(Constants/* REMOVE_GLOBAL_STYLE */.XJ === null || Constants/* REMOVE_GLOBAL_STYLE */.XJ === void 0 ? void 0 : Constants/* REMOVE_GLOBAL_STYLE.includes */.XJ.includes((ref = props.cardFrameConfig) === null || ref === void 0 ? void 0 : ref.imageShape)) ? imageWidth < 60 ? "imgWrapperGlobalStyleMin" : "imgWrapperGlobalStyle" : ""),
            style: (0,_object_spread/* default */.Z)({}, styling.style, props.imageWrapperStyles),
            children: [
                authorMedia.type !== Constants/* MEDIA_TYPES.VIDEO */.w_.VIDEO ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    className: "removeGlobalOverride tw-w-full tw-object-cover",
                    src: authorMedia.link || Constants/* DEFAULT_IMAGE */.UF
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                    src: authorMedia.link || Constants/* DEFAULT_IMAGE */.UF,
                    autoPlay: true,
                    loop: true,
                    muted: true,
                    style: (0,_object_spread/* default */.Z)({}, styling.style),
                    className: "removeGlobalOverride tw-max-w-full tw-object-cover"
                }),
                showImageLoader && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "tw-absolute tw-inset-0 tw-flex tw-items-center tw-justify-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(globalLoader/* GlobalLoader */.k, {
                        type: "loader1"
                    })
                })
            ]
        });
    };
    var renderByDataId = function renderByDataId(id) {
        switch(id){
            case Constants/* ORDER_DATA_IDS.RATING */.PK.RATING:
                var ref;
                return showRatings && /*#__PURE__*/ (0,jsx_runtime.jsx)(Rating, {
                    isContentCenter: isContentCenter,
                    isLayout4: isLayout4,
                    cardAnimationClass: cardAnimationClass,
                    ratingCount: ratingCount,
                    ratingColor: (ref = props.cardFrameConfig) === null || ref === void 0 ? void 0 : ref.ratingColor
                });
            case Constants/* ORDER_DATA_IDS.REVIEW */.PK.REVIEW:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Review, {
                    authorImagePosition: authorImagePosition,
                    isLayout4: isLayout4,
                    cardAnimationClass: cardAnimationClass,
                    reviewStyles: reviewStyles,
                    testimonialData: props.testimonialData,
                    headlineStylesFromConfig: headlineStylesFromConfig,
                    reviewStylesFromConfig: reviewStylesFromConfig,
                    textAlignmentStyle: textAlignmentStyle,
                    isMobile: props.isMobile,
                    listPresentationConfig: props.listPresentationConfig
                });
            case Constants/* ORDER_DATA_IDS.AUTHOR_INFO */.PK.AUTHOR_INFO:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthorInfo, {
                    isContentCenter: isContentCenter,
                    authorImagePosition: authorImagePosition,
                    isLayout4: isLayout4,
                    cardAnimationClass: cardAnimationClass,
                    renderAuthorImage: renderAuthorImage,
                    showImage: showImage,
                    colorConfig: colorConfig,
                    textAlignmentStyle: textAlignmentStyle,
                    testimonialData: props.testimonialData,
                    cardFrameConfig: props.cardFrameConfig,
                    authornameStyles: authornameStyles,
                    authorProfileStyles: authorProfileStyles
                });
            default:
                return null;
        }
    };
    var getDataByOrder = function getDataByOrder() {
        return props.dataOrder.map(function(data) {
            return renderByDataId(data === null || data === void 0 ? void 0 : data.id);
        });
    };
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var ref8 = (0,WidgetDndContext/* useWidgetDndContextData */.KX)(), _widgetContextState = ref8.widgetContextState, selectedWidgetSessionState = _widgetContextState.selectedWidgetSessionState, widgets = _widgetContextState.widgets, activeWidgetId = _widgetContextState.activeWidgetId;
    var infoWrapperStyles = props.infoWrapperConfig || {};
    var _testimonialData = props.testimonialData, review = _testimonialData.review, authorMedia = _testimonialData.authorMedia, ratingCount = _testimonialData.ratingCount;
    var reviewStyles = props.reviewConfig || {};
    var cardWidth = props.oneGridCellGeometry.width;
    var _ref = props.authorInfoConfig || {}, tmp = _ref.authornameConfig, ref9 = tmp === void 0 ? {} : tmp, ref9 = ref9 !== null ? ref9 : (0,_throw/* default */.Z)(new TypeError("Cannot destructure undefined")), tmp1 = _ref.authorProfileConfig, ref10 = tmp1 === void 0 ? {} : tmp1, ref10 = ref10 !== null ? ref10 : (0,_throw/* default */.Z)(new TypeError("Cannot destructure undefined")), authornameStyles = (0,_extends/* default */.Z)({}, _ref.authornameConfig), authorProfileStyles = (0,_extends/* default */.Z)({}, _ref.authorProfileConfig);
    var ref11 = (0,useLayoutTypes/* useLayoutTypes */.V)({
        listPresentationConfig: props.listPresentationConfig
    }), isLayout6 = ref11.isLayout6, isLayout5 = ref11.isLayout5, isLayout4 = ref11.isLayout4;
    var ref12 = (0,react.useState)(Constants/* CARD_ANIMATION_CLASSES.BASE */.YI.BASE + Constants/* CARD_ANIMATION_CLASSES.INACTIVE */.YI.INACTIVE), cardAnimationClass = ref12[0], setCardAnimationClass = ref12[1];
    var shouldAdjustCardPaddingX = props.isMobile && props.listPresentationConfig.numColumnsMobile === 1;
    var cardWrapperConfigs = (0,utils/* getCartWrapperConfigs */.Ui)(props.listPresentationConfig);
    var showBorder = cardWrapperConfigs.isCardLayout;
    var colorConfig = (ref = props.listPresentationConfig) === null || ref === void 0 ? void 0 : (ref1 = ref.colors) === null || ref1 === void 0 ? void 0 : (ref4 = ref1.colorSchemes) === null || ref4 === void 0 ? void 0 : ref4[(ref2 = props.listPresentationConfig) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.colors) === null || ref3 === void 0 ? void 0 : ref3.selectedColorSchemeIndex];
    var authorImagePosition = (0,Utils/* getAuthorImagePositionInfo */.Px)({
        pos: (ref5 = props.cardFrameConfig) === null || ref5 === void 0 ? void 0 : ref5.authorImagePosition,
        isMobileAndL5: isLayout5 && props.isMobile
    });
    var activeWidget = widgets === null || widgets === void 0 ? void 0 : widgets[activeWidgetId];
    var activeWidgetProps = activeWidget === null || activeWidget === void 0 ? void 0 : activeWidget.props;
    var isSelected = (activeWidgetProps === null || activeWidgetProps === void 0 ? void 0 : activeWidgetProps.subWidgetIndex) === props.index && (props === null || props === void 0 ? void 0 : (ref6 = props.listPresentationConfig) === null || ref6 === void 0 ? void 0 : ref6.type) === (activeWidgetProps === null || activeWidgetProps === void 0 ? void 0 : (ref7 = activeWidgetProps.listPresentation) === null || ref7 === void 0 ? void 0 : ref7.type);
    var showImageLoader = isSelected && selectedWidgetSessionState.isAvatarLoading;
    var ref13 = (0,Utils/* getStylesAndUtilsFromConfig */.l8)({
        isMobile: props === null || props === void 0 ? void 0 : props.isMobile,
        cardFrameConfig: props === null || props === void 0 ? void 0 : props.cardFrameConfig
    }), headlineStylesFromConfig = ref13.headlineStylesFromConfig, reviewStylesFromConfig = ref13.reviewStylesFromConfig, imageWidth = ref13.imageWidth, isContentCenter = ref13.isContentCenter, textAlignmentStyle = ref13.textAlignmentStyle, showImage = ref13.showImage, showRatings = ref13.showRatings;
    (0,react.useEffect)(function() {
        if (isLayout4) {
            var BASE = Constants/* CARD_ANIMATION_CLASSES.BASE */.YI.BASE, ACTIVE = Constants/* CARD_ANIMATION_CLASSES.ACTIVE */.YI.ACTIVE, INACTIVE = Constants/* CARD_ANIMATION_CLASSES.INACTIVE */.YI.INACTIVE;
            setCardAnimationClass(BASE + ((props === null || props === void 0 ? void 0 : props.isActiveCard) ? ACTIVE : INACTIVE));
        }
    }, [
        isLayout4,
        props === null || props === void 0 ? void 0 : props.isActiveCard
    ]);
    var wrapperStyling = (0,Utils/* getWrapperStyles */.p1)({
        showBorder: showBorder,
        listPresentationConfig: props === null || props === void 0 ? void 0 : props.listPresentationConfig,
        isSelected: isSelected,
        shouldAdjustCardPaddingX: shouldAdjustCardPaddingX
    });
    if (!(review === null || review === void 0 ? void 0 : review.trim())) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()("tw-relative tw-flex tw-flex-shrink-0 tw-items-start tw-justify-between tw-rounded-[8px]", cardWrapperConfigs.isCardLayout && "tw-py-[24px] ".concat(props.isMobile ? "tw-px-[14px]" : "tw-px-[20px]"), wrapperStyling.className),
        style: (0,_object_spread/* default */.Z)({
            width: "".concat(cardWidth, "px")
        }, wrapperStyling.style),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "tw-flex tw-w-full tw-items-start tw-justify-between tw-gap-[5%]",
            children: [
                isSelected && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "tw-absolute -tw-left-[1px] -tw-top-[1px] tw-z-50 tw-w-[108px] tw-bg-[#2F80ED] tw-px-[12px] tw-py-[4px] tw-text-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "tw-z-50 tw-text-nowrap tw-text-[14px] tw-font-normal tw-text-[#fff]",
                        children: "Testimonial ".concat((activeWidgetProps === null || activeWidgetProps === void 0 ? void 0 : activeWidgetProps.subWidgetIndex) + 1)
                    })
                }),
                authorImagePosition.left && renderAuthorImage(),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classnames_default()("tw-flex tw-flex-1 tw-flex-col tw-justify-between", isContentCenter ? "tw-items-center" : "", authorImagePosition.left ? "tw-my-auto" : ""),
                    children: [
                        authorImagePosition.top && renderAuthorImage(),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classnames_default()("tw-items tw-flex tw-flex-1 tw-flex-col tw-items-stretch tw-justify-between tw-overflow-hidden", authorImagePosition.top && (isLayout6 ? "tw-mt-[32px] !tw-gap-[20px]" : "tw-mt-[24px] !tw-gap-[16px]")),
                            style: infoWrapperStyles,
                            children: getDataByOrder()
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var Components_Card = (Card);

// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentation/ListPresentation.module.scss
var ListPresentation_module = __webpack_require__(81673);
var ListPresentation_module_default = /*#__PURE__*/__webpack_require__.n(ListPresentation_module);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentation/hooks/useAutoScrollOrRotation.tsx
var useAutoScrollOrRotation = __webpack_require__(43438);
// EXTERNAL MODULE: ./src/containers/AdditionalPage/constant.ts
var constant = __webpack_require__(26061);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentation/components/Testimonials/Testimonials.tsx









var Testimonials = function(param) {
    var listPresentationConfig = param.listPresentationConfig, cardFrameConfig = param.cardFrameConfig, oneGridCellGeometry = param.oneGridCellGeometry, isBuilder = param.isBuilder, isMobile = param.isMobile, itemCountTotal = param.itemCountTotal, gridGapAxis = param.gridGapAxis, sectionContainerRef = param.sectionContainerRef, carouselIndicatorConfigs = param.carouselIndicatorConfigs, containerTracks = param.containerTracks, isTestimonialListingPage = param.isTestimonialListingPage;
    var isCarousel = (listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.layoutType) === constant/* LAYOUT_TYPE.CAROUSEL */.y.CAROUSEL;
    var dataOrder = (cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.childElementOrder) || [];
    var testimonialsData = (0,Utils/* getViewableTestimonials */.EX)({
        cardFrameConfig: cardFrameConfig,
        isCarousel: isCarousel,
        isTestimonialListingPage: isTestimonialListingPage,
        containerTracks: containerTracks
    });
    var totalItems = testimonialsData === null || testimonialsData === void 0 ? void 0 : testimonialsData.length;
    var config = Constants/* CARD_DEFAULT_CONFIGS */.ko[listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.layoutName];
    var ref = (0,useAutoScrollOrRotation/* useAutoScrollOrRotation */.o)({
        listPresentationConfig: listPresentationConfig
    }), isAutoScrollEnabled = ref.isAutoScrollEnabled, autoScrollTimer = ref.autoScrollTimer, isAutoRotateEnabled = ref.isAutoRotateEnabled, autoRotateTimer = ref.autoRotateTimer;
    var columns = containerTracks.numColumns;
    var showAutoRotation = isCarousel && isAutoRotateEnabled && autoRotateTimer && totalItems > columns;
    var effectiveTestimonialsData = showAutoRotation ? testimonialsData.concat(testimonialsData.slice(0, columns)) : testimonialsData;
    // used only in case of layout-4
    var activeTestimonialIdx = (0,Utils/* getActiveTestimonialIndex */.At)({
        carouselIndicatorConfigs: carouselIndicatorConfigs,
        totalItems: totalItems
    });
    var allTestimonialCards = effectiveTestimonialsData.map(function(testimonialData, index) {
        var testimonialIndex = index % totalItems;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Components_Card, (0,_object_spread/* default */.Z)({
            dataOrder: dataOrder,
            testimonialData: testimonialData,
            listPresentationConfig: listPresentationConfig,
            cardFrameConfig: cardFrameConfig,
            oneGridCellGeometry: oneGridCellGeometry,
            isBuilder: isBuilder,
            isMobile: isMobile,
            index: testimonialIndex,
            isActiveCard: testimonialIndex === activeTestimonialIdx,
            imageWrapperStyles: (0,Utils/* getImageWrapperStyles */.C_)(cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.imageShape, testimonialIndex)
        }, config), (testimonialData === null || testimonialData === void 0 ? void 0 : testimonialData.id) || index);
    });
    if (isCarousel && isAutoScrollEnabled) {
        var ref1;
        var groupWidth = oneGridCellGeometry.width * itemCountTotal + itemCountTotal * gridGapAxis.columnGap;
        var testimonialCardWithWrapper = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            style: {
                gap: gridGapAxis.columnGap,
                maxWidth: groupWidth,
                width: groupWidth,
                paddingRight: gridGapAxis.columnGap,
                animationDuration: autoScrollTimer * Math.ceil(totalItems / columns) + "s"
            },
            className: (ListPresentation_module_default()).group,
            children: allTestimonialCards
        });
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            style: {
                maxWidth: (ref1 = sectionContainerRef.current) === null || ref1 === void 0 ? void 0 : ref1.clientWidth
            },
            className: (0,bundle_mjs/* twMerge */.m6)((ListPresentation_module_default()).carousel, "tw-pb-[10px] tw-pt-[35px]"),
            children: [
                testimonialCardWithWrapper,
                testimonialCardWithWrapper,
                testimonialCardWithWrapper
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: allTestimonialCards
    });
};
/* harmony default export */ var Testimonials_Testimonials = (Testimonials);

;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentation/components/Testimonials/index.tsx



/***/ }),

/***/ 88583:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ ProductRating; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14924);
/* harmony import */ var _mui_material_Rating__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60437);
/* harmony import */ var _mui_material_Rating__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2409);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50066);



var ProductRating = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(_mui_material_Rating__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
    displayName: "ProductRating",
    componentId: "sc-2332941-0"
})(function(props) {
    var _obj;
    return _obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "&.".concat(_mui_material_Rating__WEBPACK_IMPORTED_MODULE_3__/* ["default"].root */ .Z.root), {
        fontSize: props.fontSize || "16px",
        lineHeight: 1,
        height: props.fontSize || "16px"
    }), //   [`& .${ratingClasses.iconFilled}`]: {
    //     color: '#ff6d75',
    //   },
    (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "& .".concat(_mui_material_Rating__WEBPACK_IMPORTED_MODULE_3__/* ["default"].iconEmpty */ .Z.iconEmpty), {
        color: props.emptyIconColor || "#171C2A33"
    }), _obj;
});


/***/ }),

/***/ 18042:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ TestimonialRating; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var src_components_DesignSystem_Widgets2_0_ProductCard_muiStyles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88583);
/* harmony import */ var _mui_icons_material_StarSharp__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28218);



var TestimonialRating = function(param) {
    var ratingCount = param.ratingCount, _color = param.color, color = _color === void 0 ? "#F9CC43" : _color;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_DesignSystem_Widgets2_0_ProductCard_muiStyles__WEBPACK_IMPORTED_MODULE_1__/* .ProductRating */ .v, {
        value: ratingCount,
        sx: {
            color: color
        },
        fontSize: "20px",
        precision: 0.1,
        readOnly: true,
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_StarSharp__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            fontSize: "inherit"
        }),
        emptyIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_StarSharp__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            fontSize: "inherit"
        })
    });
};


/***/ }),

/***/ 26061:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ ADDITIONAL_PAGE_TYPE; },
/* harmony export */   "y": function() { return /* binding */ LAYOUT_TYPE; }
/* harmony export */ });
var ADDITIONAL_PAGE_TYPE = {
    BLOG: "blog",
    NEW_BLOG: "NewBlog",
    TESTIMONIAL: "testimonial",
    HOME: "home",
    NEW_TESTIMONIALS: "Testimonials"
};
var LAYOUT_TYPE = {
    GRID: "grid",
    CAROUSEL: "carousel"
};


/***/ }),

/***/ 40872:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _extends; }
/* harmony export */ });
function extends_() {
  extends_ = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return extends_.apply(this, arguments);
}

function _extends() {
  return extends_.apply(this, arguments);
}


/***/ })

}]);